<template>
    <b-col sm="12" lg="6">
      <b-card no-body class="newport">
        <b-row>
          <b-col sm="12" lg="12">
            <b-card-body class="pb-0" style="padding:5px;">
              <h6 class="mb-0">{{this.location.name}}</h6>
              <p style="margin-bottom:0px;"><small class="text-muted" style="color: grey !important;">{{this.location.description}}</small></p>
              <table style="margin-top:0px;margin-left: -15px;">
                <tbody>
                  <tr>
                    <td>
                    <i class="icon-user navbar" v-if="gender == 'male'" style="color: orange;"></i>
                    <i class="icon-user-female navbar" v-if="gender == 'female'" style="color: orange;"></i>
                    <i class="icon-user navbar" v-if="gender == null" style="color: orange;"></i>
                    </td>
                    <td nowrap><small class="text-muted" style="color: orange !important;">Owner: {{this.location.owner.name}}</small></td>
                    <td><i class="icon-phone navbar" style="color: green;"></i></td>
                    <td>
                      <small class="text-muted" style="color: green !important;">{{this.location.owner.phone}}
                        <a :href="whatsapp(this.location.owner.phone)" :target="this.location.owner.phone"><i class="fa fa-whatsapp"></i></a>
                      </small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'Authorization': data.access_token,
      'accessToken': data.accessToken,
      'access_token': data.access_token
    },
    method: 'POST'
  })
    .then(res => res.json())
}

export default {
  name: 'location-card',
  props: ['locationName', 'locationDescription', 'ownerName', 'ownerPhone', 'gender', 'location'],
  data: () => {
    return {
      locations: []
    }
  },
  methods: {
    details (link, locId) {
      link = link + locId
      location.href = link
    },
    whatsapp (phone) {
      let phoneNoPlus = phone.slice(1)
      return 'https://api.whatsapp.com/send?phone=' + phoneNoPlus
    },
    selectLocation (locId) {
      localStorage.setItem('locationId', locId)
      location.href = '/#/Newport/' + locId
      location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LocationCard.vue